import * as Yup from "yup"
import { LegacyGeozoneType } from "../../../api/types/Geozone"

// form field names
export type TFormFieldNames = "id" | "type"

// initial values for the form
export const formInitialValues = {
  id: "",
  type: LegacyGeozoneType.CIRCLE
}

// validation schema for the form
export const YupValidationSchema = Yup.object().shape({
  id: Yup.string()
    .required("Please enter the id of the geozones")
    .matches(/^[a-z0-9\-_]+$/, 'Only lowercase characters, numbers, hyphens, and underscores are allowed'),

  type: Yup.string()
    .required("Please select the type of the geozones")
})